
import { GlobalSettingsRepository } from '../repositories/GlobalSettingsRepository';

export class GlobalSettingsService {
  private repository: GlobalSettingsRepository;

  constructor() {
    this.repository = GlobalSettingsRepository.getInstance();
  }

  public async getList(): Promise<any> {
    return await this.repository.getAllGlobalSettings();
  }

  public async update(payload: any): Promise<any> {
    return await this.repository.updateGlobalSettings(payload);
  }

}

// Export singleton instance
export const globalSettingsService = new GlobalSettingsService();
